export default "__VITE_ASSET__8756ebaa__"